import React, { useState } from 'react'

import { selectBusinessEvents, selectBusinessEventsLoading } from '../../../../../store/businessEvent/businessEvent'
import { displaySidebar } from '../../../../../store/meetingSummary/display'
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks'

import { BusinessEventIcon } from '../../../../../components/BusinessEvent/BusinessEventIcon/BusinessEventIcon'
import PrizeBadge from '../../../../../components/ScopedBlock/PrizeBadge.svg?url'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'
import { Modal } from '../../../../../components/Modal/Modal'

import { DELTA_TRIAL_FEATURES } from '../../../../../views/Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../../../../../views/Plan/DeltaTrial/Upsell/Upsell'

import { SidebarTitle, SidebarType } from '../Sidebar/models'

import './BusinessEvents.scss'

export const MeetingBusinessEvents = () => {
  const dispatch = useAppDispatch()

  const { hasQuota } = useZocksQuota()

  const businessEventsEnabled = hasQuota('ai.businessEvent.value')

  const businessEvents = useAppSelector(selectBusinessEvents)
  const isLoading = useAppSelector(selectBusinessEventsLoading)

  const [showModal, setShowModal] = useState<boolean>(false)

  const handleClick = () => {
    dispatch(displaySidebar({ type: SidebarType.BUSINESS_EVENTS, title: SidebarTitle.BUSINESS_EVENTS, icon: '' }))
  }

  const handleShowModal = () => {
    setShowModal(true)
  }

  const handleHideModal = () => {
    setShowModal(false)
  }

  if (isLoading) {
    return null
  }

  if (!businessEventsEnabled) {
    return (
      <>
        {showModal ? (
          <Modal
            size='xl'
            className='d-flex align-items-center'
            bodyClassName='p-0'
            show={showModal}
            onHide={handleHideModal}
            body={
              <div className='position-relative'>
                <Upsell feature={DELTA_TRIAL_FEATURES['businessEvents']} />
                <i className='bi bi-x-lg position-absolute meeting-business-events-modal-hide-button cursor-pointer' onClick={handleHideModal} />
              </div>
            }
            centered={true}
          />
        ) : null}
        <div className='disabled-meeting-business-events-container p-4 border rounded-2 position-relative cursor-pointer' onClick={handleShowModal}>
          <div className='disabled-meeting-business-events-inner-container d-flex flex-column justify-content-center gap-1'>
            <span className='paragraph-small text-nowrap'>Upgrade to access Client Signals</span>
            <a
              className='zocks-text-primary paragraph-small text-decoration-underline'
              href='https://help.zocks.io/en/articles/13421694-zocks-client-signals'
              target='_blank'
              rel='noopener noreferrer'
            >
              Learn more
            </a>
          </div>
          <img className='position-absolute' alt='Upgrade' src={PrizeBadge} />
        </div>
      </>
    )
  }

  if (!businessEvents.length) {
    return null
  }

  return (
    <div
      className='meeting-business-events-container d-flex align-items-center zocks-gap-1.25 p-4 border rounded-2 zocks-border-color-gray-300 cursor-pointer'
      onClick={handleClick}
    >
      <div className='meeting-business-events-circle-container'>
        <div className='meeting-business-events-circle'></div>
        <div className='meeting-business-events-count-container d-flex align-items-center justify-content-center'>
          <BusinessEventIcon />
          <h6>{businessEvents.length}</h6>
        </div>
      </div>
      <span className='lead-small zocks-text-gray-900'>Client Signals</span>
      <i className='bi bi-chevron-right' />
    </div>
  )
}
